import React, { Component } from 'react';
import {
  Nav,
  Navbar,
  NavItem
} from 'react-bootstrap';

import './App.css';

class App extends Component {
  componentDidMount() {
    if (this.props.history.location.pathname === "/profile") { return; }
    this.goTo('home');
  }

  goTo(route) {
    this.props.history.replace(`/${route}`);
  }

  login() {
    this.props.auth.login();
  }

  logout() {
    this.props.auth.logout();
  }

  render() {
    const { isAuthenticated } = this.props.auth;

    return (
      <Navbar inverse className="App-navbar">
        <Navbar.Header>
          <Navbar.Brand>
            Employee Paid Time Off
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <NavItem onClick={this.goTo.bind(this, 'home')}>Home</NavItem>
            {
              !isAuthenticated() && (
                <NavItem onClick={this.login.bind(this)}>
                  Login
                </NavItem>
              )
            }
            {
              isAuthenticated() && (
                <NavItem onClick={this.logout.bind(this)}>
                  Logout
                </NavItem>
              )
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js